import { useTranslation } from "react-i18next";

import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

import ReactPlayer from "react-player/file";

import { MessageToast, ToastMode } from "../shared/MessageToast";

import { MeasurementType } from "../shared/enums/Result";

interface Props {
  url?: string;
  loading: boolean;
  error?: boolean;
  measurementType: MeasurementType;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
    },
    errorContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      marginTop: theme.spacing(2),
    },
  }),
);

export function MeasurementAudio(props: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  if (props.error)
    return (
      <div className={classes.errorContainer}>
        <MessageToast
          text={t("common.dataFetchError", { val: "$t(results.audioFiles)" })}
          mode={ToastMode.Error}
          show
        />
      </div>
    );
  else
    return (
      <Card className={classes.root} variant="outlined">
        <CardContent>
          {props.loading ? (
            <Skeleton variant="text" width="20%" />
          ) : (
            <Typography variant="subtitle2" gutterBottom>
              {props.measurementType === MeasurementType.Ultra && t("audio.ultrasonic")}
              {props.measurementType === MeasurementType.UHF && t("audio.uhf")}
            </Typography>
          )}

          {props.loading ? (
            <Skeleton variant="rectangular" height="50px" width="100%" />
          ) : (
            <ReactPlayer className="react-player" url={props.url} height="50px" width="100%" controls={true} />
          )}
        </CardContent>
      </Card>
    );
}
